module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_DKGrey.42424ba4.png";